import React from 'react'

function SettingsContent() {
  return (
    <div className='h-full flex flex-col bg-gray-700  transition-colors duration-200'>SettingsContent</div>
  )
}

export default SettingsContent